import Axios from "axios";
import dayjs from "dayjs";
import React, { useContext } from "react";
import { configContext } from "../config-provider";
import { DataTable } from "../data-table";
import { Spin } from "../loading";
import { Pagniation } from "../pagination";
import { buildExportName } from "../../utils";

interface DateDataTableProps {
  title: string;
  subtitle: string;
  path: string;
}

interface State {
  date: string;
  prevDate: string;
  data: any[];
  loading: boolean;

  paginate: {
    currentPage: number;
    total: number;
    take: number;
  };
}

const take = 10;

const initialState: State = {
  date: dayjs().subtract(2, "month").format("YYYY-MM"),
  prevDate: dayjs().subtract(2, "month").format("YYYY-MM"),
  data: [] as any[],
  loading: false,
  paginate: {
    currentPage: 1,
    take,
    total: Infinity,
  },
};

export const InspectionPage: React.FC<DateDataTableProps> = (props) => {
  const { title, subtitle, path } = props;
  const { dataStartMonth } = useContext(configContext);

  const [state, setState] = React.useState<State>(initialState);
  const [allData, setAllData] = React.useState<any[]>([]);

  React.useEffect(() => {
    fetch();
  // eslint-disable-next-line
  }, [state.date, state.paginate]);

  const fetch = () => {
    const isNotMonth = state.prevDate === state.date;
    const isLoading = state.loading;
    const { date, paginate } = state;

    if (!isLoading || !isNotMonth) {
      setState((prev) => ({ ...prev, loading: true }));
      Axios.get<[[], number]>(`/${path.toLowerCase()}`, {
        params: {
          date,
          skip: (paginate.currentPage - 1) * paginate.take,
          take: paginate.take,
        },
      })
        .then((res) => {
          const [data, total] = res.data;

          const { paginate } = state;
          setState((prev) => ({
            ...prev,
            data,
            paginate: {
              ...paginate,
              total,
              take,
            },
            prevDate: prev.date,
          }));
        })
        .finally(() => {
          setState((prev) => ({ ...prev, loading: false }));
        });

      Axios.get<[[], number]>(`/${path.toLowerCase()}`, {
        params: {
          date,
        },
      })
        .then((res) => {
          const [data, total] = res.data;
          setAllData(data);
        })
    }
  };

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;

    setState((prev) => ({
      ...prev,
      prevDate: prev.date,
      date: value,
      paginate: { ...initialState.paginate },
    }));
  };

  const onChange = (page: number, pageSize: number) => {
    setState((prev) => ({
      ...prev,
      paginate: {
        ...prev.paginate,
        currentPage: page,
        take: pageSize,
      },
    }));
  };

  return (
    <div className="date-datatable">
      <div className="top">
        <span className="title">{title}</span>
        <span className="subtitle">{subtitle}</span>
        <input
          type="month"
          min={dataStartMonth}
          value={state.date}
          onChange={handleDateChange}
        />
      </div>
      <div className="bottom">
        <Spin spin={state.loading}>
          {state.data.length > 0 && (
            <>
              <DataTable
                exportName={buildExportName(title, subtitle, state.date)}
                columns={Object.keys(state.data[0]).map((key) => ({
                  title: key,
                  dataIndex: key,
                }))}
                data={state.data}
                allData={allData}
              />
              <Pagniation onChange={onChange} {...state.paginate} />
            </>
          )}
        </Spin>
      </div>
    </div>
  );
};
